var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('kt-panel',[(_vm.$can('read', 'ticket'))?_c('kt-panel-body',[_c('ManageAccessForm',{attrs:{"action":_vm.createTicket}})],1):_c('kt-panel-body',[_c('ticket-form',{attrs:{"action":_vm.createTicket}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }